export const oauth = {
  OAUTH: 'accounts/apps',
  OAUTH_ID: 'accounts/apps/{id}',
  OAUTH_SECRET: 'accounts/apps/{id}/secret',
  DOMAINS: 'accounts/auth-setting',
};
